import urls from "../../api/urls.json";
import Loader from "../Loader";
import { React, useState, useRef, useEffect } from 'react';
import { BaseButton, BottomButton } from "../../styles/ButtonStyles";
import { ImageCirlceView, ImageDivView, ImageDivFeed } from "../../styles/ImageWrapper";
import { FlexWrapper, LineView, GapView } from "../../styles/WrapperStyles";
import styled, { css } from 'styled-components';
import { authorizedHttpGet, authorizedHttpPost } from "../../api/httpCalls";
import CropImage from '../CropImage';
import PageModal from "../modals/PageModal";
import LeftNav from "../LeftNav";
import '../styles/Member.css';
import CaptureGooglePaymentModal from "../modals/CaptureGooglePaymentModal";
import placeholder_image from "../../assests/placeholder_image.png";
import previous_inctive from '../../assests/arrow_back_grey.png';
import next_inactive from '../../assests/arrow_forward_grey.png';
import previous_active from '../../assests/arrow_back.png';
import next_active from '../../assests/arrow_forward.png';
import { useLocation, useNavigate } from "react-router-dom";
import { convertTimestampToFormattedDate } from "../../utils";
import FeedDetailedProfileView from "./FeedDetailedProfileView";
import EmptyView from '../EmptyView';
import MessageModal from "../modals/MessageModal";
import ProfileStateListModal from "../modals/ProfileStateListModal";
import ActivityModal from "../modals/ActivityModal";
import InvoicesModal from "../modals/InvoicesModal";
import InvitesModal from "../modals/InvitesModal";
import VerifyModal from "../modals/VerifyModal";
import {
    CommonTextStyleSpan,
} from '../../styles/TextStyles';


const NameSpan = styled.span`
  color: #9b9b9b;
  ${props =>
        props.selected &&
        css`
      color: blue;
      cursor: pointer;
    `}
`;

const ProfileItemWrapper = styled(FlexWrapper)`
  margin-top: 15px;
`;

const ConnectedDiv = styled.div`
  margin-right: 20px;
  margin-top: 15px;
`;

const BottomButtonBase = styled(BottomButton)`
  margin-top: 20px;
  margin-bottom: 20px;
  cursor: pointer;
`;

const FlexBottom = styled(FlexWrapper)`
  flex-flow: wrap;
  width: 800px;
`;

const InfoDiv = styled.div`
  width: 252px;
`;

const InfoText = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  ${props =>
        props.cursor &&
        css`
      cursor: pointer;
    `}
`;

const HeaderWrapper = styled(FlexWrapper)`
    // display: inline;

    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;

const HeaderTextView = styled.span`
    font-family:'Gilory-Semi';
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #d7d7d7;
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `}
    ${props =>
        props.selected &&
        css`
        color: #767676;
        font-family: 'Gilory-Bold';
      `}
    ${props =>
        props.cursor &&
        css`
        cursor: pointer;
      `}
`;

const profileContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px
`;

const LeftCornerWrapper = styled.div`
    display: grid;
    grid-template-columns: 125px 100px;
    grid-template-rows: 255px 80px 60px 60px;
    justify-content: space-evenly;
`;

const BanButton = styled(BaseButton)`
  margin-left: 20px;
  width: 110px;
  height: 55px;
  margin-top: 50px;
  background-color: #ffffff;
  border-color: black;
  color: black;
  margin-top: 20px;
`;

const SelectedView = styled.button`
  width: 55px;
  height: 55px;
  border-radius: 27.5px;
  border: solid 5px #484848;
  color: #ffffff;
  background-color: #ffffff;
  margin-top: 20px;
  font-size: 20px;
  ${props =>
        props.selected &&
        css`
      background-color: #484848;
    `}
`;

const BottomBarWrapper = styled.div`
    margin-top: 50px;
    display:flex;
    justify-content:left;
    align-items:center;
`;

const BottomBarWrapper1 = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    margin-top: 50px;
    margin-bottom: 50px;
`;

const NameWrapper = styled.div`
//   margin-top: 250px;
  margin-left: -20px;
  ${props =>
        props.width &&
        css`
      width: ${props.width};
      max-width: ${props.maxwidth};
    `}
`;

const ArrowButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    margin-left: 50px;
`;

const SaveButton = styled(BaseButton)`
    margin-left: 20px;
    grid-column: 1/3;
`;

const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;

const ImageDivView1 = styled(ImageDivView)`
    grid-column: 1/3;
`;

const BaitProfiles = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const handleLeftNavAppChange = (name) => {
        setAppName(name)
    };
    const itemsPerPage = 1;
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    var [pos, setPos] = useState(startIndex);
    const [profiles, setProfiles] = useState([]);
    const currentProfile = profiles.slice(startIndex, endIndex);
    const [cropPhoto, setCropPhoto] = useState('')
    const [showCropImage, setShowCropImage] = useState(false);
    const [togglePageModal, setTogglePageModal] = useState(false);
    const totalPages = Math.ceil(profiles.length / itemsPerPage);
    const [apiPageChange, setApiPageChange] = useState(1);
    const totalPagesApi = useRef(0);
    const totalProfiles = useRef(0);
    const [isLoading, setIsLoading] = useState(false)
    const newApiPageChange = useRef(1);
    const [page, setPage] = useState(1);
    const [currentTab, setCurrentTab] = useState("Suspects");
    const [decoy, setDecoy] = useState(false);
    const [displyFeedView, setDisplyFeedView] = useState(false);
    const [displayProfileStateModal, setDisplayProfileStateModal] = useState(false);
    const [displayActivityModal, setDisplayActivityModal] = useState(false);
    const [params, setParams] = useState({});
    const [displayInvoicesModal, setDisplayInvoicesModal] = useState(false);
    const [displayInvitesModal, setDisplayInvitesModal] = useState(false);
    const [otherUserRef, setOtherUserRef] = useState('');
    const [displaySelfieModal, setDisplaySelfieModal] = useState(false);
    const [displayMessageModal, setDisplayMessageModal] = useState(false);
    const [displayMessage, setDisplayMessage] = useState(false);
    const [isSelfieVerified, setIsSelfieVerified] = useState("No");
    const [connectionsPage, setConnectionsPage] = useState(1);
    const [displayPageModal, setDisplayPageModal] = useState(false);
    const [selfieUrl, setSelfieUrl] = useState('');

    const getUsers = async () => {
        setIsLoading(true)
        let state = {
            "Suspects": "pending",
            "Checked": "checked",
            "Address": "addressed"
        }
        let response = await authorizedHttpGet(urls.BAIT_PROFILE, { page: apiPageChange, state: state[currentTab] })
        if (response.status) {
            totalPagesApi.current = response.data.total_pages
            totalProfiles.current = response.data.total_profiles
            setProfiles(response.data.partner_profiles)
            newApiPageChange.current = response.data.page
        }
        setIsLoading(false)
    }


    useEffect(() => {
        getUsers()
    }, [appName, currentTab, apiPageChange]);

    const closeModal = () => {
        setShowCropImage(false);
        setDisplayProfileStateModal(false);
        setDisplayActivityModal(false);
        setDisplayMessageModal(false);
        setDisplayInvitesModal(false);
        setDisplayInvoicesModal(false);
        setDisplaySelfieModal(false);
        setSelfieUrl('');
    }


    const toggleActivityModal = (filter, title) => {
        setParams({ filter: filter, title: title })
        setDisplayActivityModal(true)
    }

    const goToPage = (pageModalNumber) => {
        setTogglePageModal(false);
        if (pageModalNumber > totalPagesApi.current) {
            alert("Page number is greater than total pages");
        } else {
            setApiPageChange(pageModalNumber);
        }
    }

    const handleTabChange = (tab) => {
        setCurrentTab(tab);
        setPage(1);
        setCurrentPage(1);
        setApiPageChange(1);
    }

    const banUser = async (profileRef) => {
        setIsLoading(true);
        await authorizedHttpPost(urls.BAN_PROFILE, { "ref": profileRef })
        setIsLoading(false);
        await getUsers();
    }

    const handleFeedView = () => {
        setDisplyFeedView(true)
        localStorage.setItem('detailViewRef', currentProfile[0].profile_data.ref)
    }

    const closeFeedView = () => {
        setDisplyFeedView(false)
        localStorage.removeItem('detailViewRef')
    }

    const afterSave = async () => {
        await getUsers();
    }

    const handlePageChange = async (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            pos === startIndex ? setPos(endIndex - 1) : setPos(pos - 1);
            setCurrentPage(currentPage - 1);
            
        } else if (direction === 'next' && currentPage < totalPages) {
            pos === endIndex - 1 ? setPos(startIndex) : setPos(pos + 1);
            setCurrentPage(currentPage + 1);
            
        }
        
        if (profiles.length === currentPage && direction === 'next') {
            setApiPageChange(newApiPageChange.current + 1);
            setCurrentPage(1);
        }
    };

    const handlePageChangeCheckAddress = async (direction) => {
        if (direction === 'next') {
            setApiPageChange(newApiPageChange.current + 1);
            
        } else {
            setApiPageChange(newApiPageChange.current - 1);
        }
    }

    const handleDownload = async () => {
        setIsLoading(true)
        let response = await authorizedHttpGet(urls.DOWNLOAD_PROFILE, { ref: currentProfile[0].profile_data.ref })
        if (response.status) {
            const jsonBlob = new Blob([JSON.stringify(response.data, null, 2)], { type: 'application/json' });
            const url = URL.createObjectURL(jsonBlob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `profile_${currentProfile[0].profile_data.ref}.json`;
            a.click();
            URL.revokeObjectURL(url);
        }
        setIsLoading(false)
    }

    const saveData = async () => {
        setIsLoading(true);
        var checkedReports = [];
        var addressedReports = [];
        console.log('profiles', profiles)
        profiles.map((profile) => {
            if (profile.addressed_state) {
                addressedReports.push({ ref: profile.ref, id: profile.id });
            } else {
                checkedReports.push({ ref: profile.ref, id: profile.id });
            }
        })
        var params = {
            checkedReports: checkedReports,
            addressedReports: addressedReports
        };
        console.log('params', params)

        let response = await authorizedHttpPost(urls.BAIT_PROFILES_UPDATE, params);
        if (response.status) {
            if (response.data.status) {
                console.log('response', response.data)
                await getUsers();
            }
        }
        setIsLoading(false);
    }

    const handleInvoicesModal = async () => {
        setDisplayInvoicesModal(false)
    }

    const verifySelfie = async (type) => {
        let url = type === 'verify' ? urls.MARK_SELFIE_VERIFIED : urls.MARK_SELFIE_UNVERIFIED
        setIsLoading(true)
        let response = await authorizedHttpPost(url, { ref: currentProfile[0].profile_data.ref })
        if (response.status) {
            type === 'verify' ? setIsSelfieVerified("Yes") : setIsSelfieVerified("No")
        }
        setIsLoading(false)
        setDisplaySelfieModal(false)
    }

    return displyFeedView ? (
        <FeedDetailedProfileView closeDetailedView={closeFeedView} afterSave={afterSave} />
    ) : (
        <div className="App">
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Bait Profiles'} />
            <div className="marginLeft200">
            {displayMessageModal ? <MessageModal closeModal={closeModal} message={displayMessage} /> : null}
            {displayProfileStateModal ? <ProfileStateListModal closeModal={closeModal} profile={currentProfile[0]} /> : null}
            {displayActivityModal ? <ActivityModal closeModal={closeModal} filter={params.filter} user_ref={currentProfile[0].profile_data.ref} title={params.title} /> : null}
            {togglePageModal && <PageModal closeModal={() => setTogglePageModal(false)} goToPage={goToPage} page={apiPageChange} />}
            {displayInvoicesModal ? <InvoicesModal closeModal={() => handleInvoicesModal()} payments={currentProfile[0].invoices.payments_list} detailedViewRef={currentProfile[0].profile_data.ref} /> : null}
            {displayInvitesModal ? <InvitesModal closeModal={() => setDisplayInvitesModal(false)} other_user_ref={otherUserRef} current_user_ref={currentProfile[0].profile_data.ref} /> : null}
            {displaySelfieModal && selfieUrl ? <VerifyModal closeModal={() => setDisplaySelfieModal(false)} image={selfieUrl} verify={verifySelfie} /> : null}
            {showCropImage && <CropImage photo={cropPhoto} closeModal={closeModal} />}
            {isLoading && <Loader />}
            <div className="partnerProfilesMainDiv">
            <FlexWrapper className="marginTop25">
                    <HeaderWrapper className="cursorPointer" onClick={() => setDisplayPageModal(true)}>
                        <HeaderSelected className="marginLeft10">{newApiPageChange.current}</HeaderSelected>
                        <HeaderSelected className="marginLeft10">{totalPagesApi.current}</HeaderSelected>
                        <HeaderSelected className="marginLeft10">{totalProfiles.current}</HeaderSelected>
                    </HeaderWrapper>
                    <HeaderWrapper className="marginLeft50 cursorPointer">
                        <HeaderTextView marginRight selected={currentTab === 'Suspects' ? true : false} onClick={() => handleTabChange('Suspects')}>Suspects</HeaderTextView>
                        <HeaderTextView marginRight selected={currentTab === 'Checked' ? true : false} onClick={() => handleTabChange('Checked')}>Checked</HeaderTextView>
                        <HeaderTextView marginRight selected={currentTab === 'Address' ? true : false} onClick={() => handleTabChange('Address')}>Address</HeaderTextView>
                    </HeaderWrapper>
                </FlexWrapper>
                <GapView height="58px" />
    
                {
                (currentTab === 'Suspects') ? 
                    (currentProfile && currentProfile[0] && currentProfile[0].profile_data) ? (
                    <FlexWrapper>
                        <LeftCornerWrapper>
                        <ImageDivView1
                            height={false ? '365px' : null}
                            src={currentProfile[0].profile_data.avatar}
                            onError={e => {
                                e.target.src = placeholder_image;
                            }}
                            is_end
                        />
                        
                        <BanButton onClick={() => banUser(currentProfile[0].profile_data.ref)}>
                                BAN
                        </BanButton>
                        {(
                            <>
                                    <SelectedView className="marginLeft30"
                                        onClick={() => {
                                            // setDecoy(!decoy);
                                            var list = [...profiles];
                                            currentProfile[0].addressed_state = currentProfile[0].addressed_state
                                                ? false
                                                : true;
                                            setProfiles(list);
                                        }}
                                        selected={currentProfile[0].addressed_state}
                                        style={{ visibility: currentTab !== 'Suspects' ? 'hidden' : 'visible' }}
                                    >
                                        {currentProfile[0].addressed_state ? 'X' : ''}
                                    </SelectedView>
                            </>
                            )}
                        <BottomBarWrapper>
                            <ArrowButton>
                                    {currentPage === 1 ? <img src={previous_inctive} /> : <img src={previous_active} onClick={() => handlePageChange('prev')} />}
                                    {currentPage === 10 ? <img className="marginLeft30" src={next_inactive} onClick={() => handlePageChange('next')} /> : <img className="marginLeft30" src={next_active} onClick={() => handlePageChange('next')} />}
                            </ArrowButton>
                         </BottomBarWrapper>
                         {/* {currentTab === 'Suspects' && <SaveButton onClick={() => saveData()}>Save</SaveButton>} */}
                         {currentTab === 'Suspects' && currentPage === profiles.length && (
                            <SaveButton onClick={() => currentPage === profiles.length && saveData()}>Save</SaveButton>
                        )}
                         </LeftCornerWrapper>
                         <GapView width="50px" />
                        <div>
                            <FlexWrapper>
                                <InfoDiv>
                                    <InfoText cursor onClick={() => handleFeedView()}>
                                        {currentProfile[0].profile_data.name}
                                        <br />
                                        {currentProfile[0].profile_data.gender[0]} /{' '}
                                        {currentProfile[0].profile_data.age}
                                        <br />
                                        {currentProfile[0].profile_data.ref}
                                        <br />
                                        {currentProfile[0].profile_data.location_str}
                                    </InfoText>
                                </InfoDiv>
                                <GapView width="58px" />
                                <InfoDiv>
                                    <InfoText
                                        cursor
                                        onClick={() => {
                                            setDisplayProfileStateModal(true)
                                        }}
                                    >
                                        Status: {currentProfile[0].profile_data.profile_state}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Dates <br />
                                    </InfoText>
                                    <InfoText>
                                        Joined: {currentProfile[0].profile_data.joined ? convertTimestampToFormattedDate(currentProfile[0].profile_data.joined) : null}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Submitted:{' '}
                                        {currentProfile[0].profile_data.application_date ? convertTimestampToFormattedDate(currentProfile[0].profile_data.application_date) : null}
                                    </InfoText>{' '}
                                    <br />
                                    <InfoText>
                                        Approved:{' '}
                                        {currentProfile[0].profile_data.approved_date ? convertTimestampToFormattedDate(currentProfile[0].profile_data.approved_date) : null}
                                    </InfoText>{' '}
                                    <br />
                                    <InfoText>
                                        Deleted: {currentProfile[0].profile_data.deleted ? convertTimestampToFormattedDate(currentProfile[0].profile_data.deleted) : null}
                                    </InfoText>{' '}
                                    <br />
                                    <InfoText>
                                        Last Login: {currentProfile[0].profile_data.last_login ? convertTimestampToFormattedDate(currentProfile[0].profile_data.last_login) : null}
                                    </InfoText>{' '}
                                    <br />
                                    <InfoText>
                                        Last Seen:{' '}
                                        {currentProfile[0].profile_data.last_seen_window ? convertTimestampToFormattedDate(currentProfile[0].profile_data.last_seen_window) : null}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Last Img Update: {currentProfile[0].profile_data.last_image_update_by}
                                    </InfoText>
                                </InfoDiv>
                                <GapView width="58px" />
                                <InfoDiv>
                                    <InfoText>Contact</InfoText>
                                    <br />
                                    <InfoText>{currentProfile[0].profile_data.personal_email}</InfoText>
                                    <br />
                                    <InfoText>
                                        {currentProfile[0].profile_data.phone_code}
                                        {currentProfile[0].profile_data.mobile_number}
                                    </InfoText>
                                    <br />
                                    <InfoText>User Id: {currentProfile[0].profile_data.user_id}</InfoText>
                                    <br />
                                    <InfoText>{currentProfile[0].profile_data.device_type}</InfoText>
                                    <br />
                                    <InfoText>{currentProfile[0].profile_data.model_details}</InfoText>
                                    <br />
                                    <InfoText>
                                        App Version:{currentProfile[0].profile_data.app_version}
                                    </InfoText>
                                </InfoDiv>
                            </FlexWrapper>
                            <GapView height="30px" />
                            <LineView width="724px" />
                            <GapView height="30px" />
                            <FlexWrapper>
                                {currentProfile[0].likes_details ? (
                                    <InfoDiv>
                                        <InfoText>
                                            Likes Left: {currentProfile[0].likes_details.likes_left}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() => toggleActivityModal('likes_sent', 'Likes Sent')}
                                        >
                                            Likes Sent: {currentProfile[0].likes_details.likes_sent}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() =>
                                                toggleActivityModal('likes_passed', 'Likes Passed')

                                            }
                                        >
                                            Likes Passed: {currentProfile[0].likes_details.likes_passed}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() => toggleActivityModal('likes_received', 'Likes Received')
                                            }
                                        >
                                            Likes Received: {currentProfile[0].likes_details.likes_received}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() =>
                                                toggleActivityModal('likes_connection', 'Likes Connection')
                                            }
                                        >
                                            Likes Connections:{' '}
                                            {currentProfile[0].likes_details.likes_connection}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() =>
                                                toggleActivityModal('likes_linked', 'Likes Linked')
                                            }
                                        >
                                            Likes Linked: {currentProfile[0].likes_details.likes_linked}
                                        </InfoText>
                                    </InfoDiv>
                                ) : (
                                    <InfoDiv></InfoDiv>
                                )}
                                <GapView width="58px" />
                                <InfoDiv>
                                    <InfoText>
                                        Invites Left: {currentProfile[0].invites_details.invites_left}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('invites_sent', 'Invites Sent')
                                        }
                                    >
                                        Invites Sent: {currentProfile[0].invites_details.invites_sent}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('invites_sent_accepted', 'Invites Sent Accepted')
                                        }
                                    >
                                        Invites Sent Accepted:{' '}
                                        {currentProfile[0].invites_details.sent_accepted_requests}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('invites_received_accepted', 'Invites Received Accepted')
                                        }
                                    >
                                        Invites Received Accepted:{' '}
                                        {currentProfile[0].invites_details.received_accepted_requests}
                                    </InfoText>
                                </InfoDiv>
                                <GapView width="58px" />
                                <InfoDiv>
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('invites_received', 'Invites Received')
                                        }
                                    >
                                        Invites Received: {currentProfile[0].invites_details.invites_received}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('invites_sent_passed', 'Invites Sent Passed')
                                        }
                                    >
                                        Invites Sent Passed:{' '}
                                        {currentProfile[0].invites_details.sent_declined_requests}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('invites_received_passed', 'Invites Received Passed')
                                        }
                                    >
                                        Invites Received Passed:{' '}
                                        {currentProfile[0].invites_details.received_declined_requests}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('user_passed', 'User Passed')
                                        }
                                    >
                                        User Passed: {currentProfile[0].invites_details.pass_count}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Was Passed:{currentProfile[0].invites_details.passed_by_others}
                                    </InfoText>
                                </InfoDiv>
                            </FlexWrapper>
                            <GapView height="30px" />
                            <LineView width="724px" />
                            <GapView height="30px" />
                            <FlexWrapper>
                                <InfoDiv>
                                    <InfoText>
                                        Subscription:{' '}
                                        {currentProfile[0].profile_data.active_plan_type == null
                                            ? 'Not Active'
                                            : currentProfile[0].profile_data.active_plan_type}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            setDisplayInvoicesModal(true)
                                        }
                                    >
                                        Invoices: {currentProfile[0].invoices.total_payments}
                                    </InfoText>
                                    <br />
                                    <InfoText>Comments:{currentProfile[0].comments}</InfoText>
                                    <br />
                                    <InfoText>
                                        Warnings:{currentProfile[0].profile_data.email_sent_count}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('blocked_self', 'Blocked')
                                        }
                                    >
                                        Blocks:{currentProfile[0].block_info.blocks}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('blocked_by', 'Blocked By')
                                        }
                                    >
                                        Blocked By:{currentProfile[0].block_info.blocked_by}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Connections:{currentProfile[0].connections.active_connections}
                                    </InfoText>
                                    <br />
                                </InfoDiv>
                                <GapView width="58px" />
                                <InfoDiv>
                                    <InfoText>
                                        Message received: {currentProfile[0].messages_count.received}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Messages sent:{currentProfile[0].messages_count.sent}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Rooms:{currentProfile[0].is_room_active ? 'Active' : 'Inactive'}
                                    </InfoText>
                                    <br />
                                    <InfoText>

                                        Selfie Verified: {isSelfieVerified}
                                    </InfoText>
                                    <br />
                                    {currentProfile[0].verification_status.selfie_url ? (
                                        <div>
                                            <InfoText
                                                cursor
                                                onClick={() => {
                                                    setSelfieUrl(currentProfile[0].verification_status.selfie_url);
                                                    setDisplaySelfieModal(true);
                                                }}
                                            >
                                                Selfie Url
                                            </InfoText>
                                        </div>
                                    ) : null}
                                    <InfoText>Rating:{currentProfile[0].rating}</InfoText>
                                    <br />
                                    <InfoText>Mean Score:{currentProfile[0].mean_rating}</InfoText>
                                </InfoDiv>
                                <GapView width="58px" />
                                {currentProfile[0].boost_info ? (
                                    <InfoDiv>
                                        <InfoText>
                                            Boost purchased: {currentProfile[0].boost_info.boost_purchased}
                                        </InfoText>
                                        <br />
                                        <InfoText>
                                            Boost used: {currentProfile[0].boost_info.boost_used}
                                        </InfoText>
                                        <br />
                                        <InfoText>
                                            Boost left: {currentProfile[0].boost_info.boost_left}
                                        </InfoText>
                                        <br />
                                    </InfoDiv>
                                ) : null}
                            </FlexWrapper>
                            <GapView height="30px" />
                            <LineView width="724px" />
                            <GapView height="15px" />
                            <FlexBottom>
                                {currentProfile[0].connections.connected_profiles.map(item => {
                                    return (
                                        <ConnectedDiv
                                            key={item.ref}
                                            onClick={() => {
                                                setDisplayInvitesModal(true);
                                                setOtherUserRef(item.ref);
                                            }}
                                        >
                                            <div>
                                                <ImageCirlceView src={item.avatar} />
                                            </div>
                                            <FlexWrapper>
                                                <GapView width="15px" />
                                                <InfoText>
                                                    {item.first_name}
                                                    <br />
                                                    {item.ref}
                                                    <br />
                                                    Sent:{item.messages_sent}
                                                    <br />
                                                    Recieved: {item.messages_received}
                                                </InfoText>
                                            </FlexWrapper>
                                        </ConnectedDiv>
                                    );
                                })}

                            </FlexBottom>

                            {isLoading ? (
                                <Loader />
                            ) : currentProfile[0].connections.total_pages > connectionsPage ? (
                                <BottomButtonBase
                                    onClick={() =>
                                        setConnectionsPage(connectionsPage + 1)
                                    }
                                >
                                    Load More
                                </BottomButtonBase>
                            ) : null}
                            <GapView height="30px" />
                            {true ? (
                                <BaseButton
                                    onClick={() => {
                                        handleDownload();
                                    }}
                                >
                                    Download
                                </BaseButton>
                            ) : null}
                        </div>
                    </FlexWrapper>
                ) : null  : (
                    <div>
                    {
                    profiles && profiles.map((profile, pos) => (
                        <ProfileItemWrapper key={profile.profile_data.ref}>
                            <ImageDivFeed
                                key={profile.profile_data.avatar}
                                src={profile.profile_data.avatar}
                                onError={e => {
                                    e.target.src = placeholder_image;
                                }}
                            />
                            <NameWrapper width="320px">
                                <CommonTextStyleSpan highlight>
                                    <NameSpan
                                        selected={profile.verification_status.selfie_url}
                                        onClick={() => {
                                            setSelfieUrl(profile.verification_status.selfie_url);
                                            setDisplaySelfieModal(true);
                                        }}
                                    >
                                        {profile.profile_data.name}
                                    </NameSpan>
                                    , {profile.profile_data.gender}, {profile.profile_data.age}
                                </CommonTextStyleSpan>
                                <CommonTextStyleSpan> {profile.profile_data.ref}</CommonTextStyleSpan>
                                <br />
                                <br />
                                <br />
                                <br />
                                <CommonTextStyleSpan>
                                    {currentTab === 'Checked' ? 'Checked by' : 'Addressed by'}: {currentTab === 'Checked' ? profile.admin_name : profile.admin_name}
                                </CommonTextStyleSpan>
                                <br />
                                <CommonTextStyleSpan>
                                    Block Count: {profile.block_info.blocked_by}
                                </CommonTextStyleSpan>
                                <br />
                                <CommonTextStyleSpan>
                                    Report Count: {profile.report_info.reported_by}
                                </CommonTextStyleSpan>
                            </NameWrapper>
                            <GapView width="20px" />
                            <BanButton onClick={() => banUser(profile.profile_data.ref)}>
                                BAN
                            </BanButton>
                        </ProfileItemWrapper>
                    ))}
                    {profiles.length > 0 && (
                        <BottomBarWrapper1>
                            {parseInt(apiPageChange) === 1 ? <img src={previous_inctive} className="cursorPointer" /> : <img src={previous_active} onClick={() => handlePageChangeCheckAddress('previous')} className="cursorPointer" />}
                            {parseInt(apiPageChange) === totalPages.current ? <img className="cursorPointer marginLeft30" src={next_inactive} onClick={() => handlePageChangeCheckAddress('next')} /> : <img className="cursorPointer marginLeft30" src={next_active} onClick={() => handlePageChangeCheckAddress('next')} />}
                        </BottomBarWrapper1>
                    )}
                    {profiles.length === 0 && <EmptyView />}
                    </div>
                )
                
            }
            </div>
            </div>
        </div>
    );

}

export default BaitProfiles;